"use client";

import type React from "react";
import { useProducts } from "./ListingContext";

export const DisplayProductsOrEmptyContent = ({
	productList,
	emptyContent,
}: {
	productList: React.ReactNode;
	emptyContent?: React.ReactNode;
}) => {
	const { total, isLoading } = useProducts();

	if (isLoading) return productList;

	return <>{total > 0 ? productList : emptyContent}</>;
};
